import IconoCircular from "./IconoCircular";
export default function CardTwo({ item }) {

    return (
        <div className="card2 item">
            <div className="img-content">
                <IconoCircular size="tecnology" ruta={item.imagen} />
            </div>
            <p>{item.name}</p>
        </div>
    );
}